import { UsersRound } from "lucide-react"
import { Link } from "react-router"

import { Badge } from "@f2e/ui/components/base"
import { ellipsis } from "@f2e/shared/utils"

import { WorkspaceProfile } from "@/types"

export interface WorkspaceBadgeProps {
  className?: string
  workspaceProfile: WorkspaceProfile
  isLink?: boolean
  limit?: number
}

const WorkspaceBadge = ({
  className,
  workspaceProfile,
  isLink = false,
  limit = 20,
}: WorkspaceBadgeProps) => {
  return (
    <Badge variant="secondary" className={className}>
      {isLink && workspaceProfile.id !== "-1" ? (
        <Link to={`/workspaces/${workspaceProfile.id}`}>
          <BadgeContent profile={workspaceProfile} limit={limit} />
        </Link>
      ) : (
        <BadgeContent profile={workspaceProfile} limit={limit} />
      )}
    </Badge>
  )
}

const BadgeContent = ({
  profile,
  limit,
}: {
  profile: WorkspaceProfile
  limit: number
}) => {
  return (
    <>
      <UsersRound className="size-4 inline-block mr-1" />
      <span>{ellipsis(profile.name || "Unknown", limit)}</span>
    </>
  )
}

export { WorkspaceBadge }
export default WorkspaceBadge
